







































































































import { Component, Prop } from 'vue-property-decorator';
import EntityType from '@/models/Shared/EntityType';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import DocumentUpload from '@/components/Documents/DocumentUpload.vue';
import DocumentEdit from '@/components/Documents/DocumentEdit.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import FileUtils from '@/lib/fileUtils';


@Component({
  name: 'Documents',
  components: { DocumentUpload, DocumentEdit }
})
export default class extends GiganautVue {

    @Prop()
    entityType: EntityType;

    async created() {
        switch (this.entityType){
            case EntityType.Worker:
                await WorkerDetailsModule.getDocuments();
                break;
            case EntityType.Company:
                await CompanyDetailsModule.getDocuments();
                break;
            case EntityType.Location:
                await LocationDetailsModule.getDocuments();
                break;
            case EntityType.Opportunity:
                await OpportunityDetailsModule.getDocuments();
                break;
        }
    }

    get documents() {
        switch (this.entityType){
            case EntityType.Worker:
                return WorkerDetailsModule.documents;
            case EntityType.Company:
                return CompanyDetailsModule.documents;
            case EntityType.Location:
                return LocationDetailsModule.documents;
            case EntityType.Opportunity:
                return OpportunityDetailsModule.documents;
        }
    }

    icon(fileExtension: string) {
        return FileUtils.getMdiIconForExtension(fileExtension);
    }

    async download(id: string) {
        switch (this.entityType){
            case EntityType.Worker:
                await WorkerDetailsModule.downloadDocument(id);
                break;
            case EntityType.Company:
                await CompanyDetailsModule.downloadDocument(id);
                break;
            case EntityType.Location:
                await LocationDetailsModule.downloadDocument(id);
                break;
            case EntityType.Opportunity:
                await OpportunityDetailsModule.downloadDocument(id);
                break;
        }

    }
}
